import { useCms } from '../lib/cms';

const fallbackGroups=[
 {title:'CAPABILITIES',links:[{label:'Services',href:'/services'},{label:'System Builder',href:'/system-builder'},{label:'Selected Work',href:'/work'}]},
 {title:'THINKING',links:[{label:'Insights',href:'/insights'},{label:'Careers',href:'/careers'},{label:'Start a project',href:'/book-call'}]},
 {title:'COMPANY',links:[{label:'Industries',href:'/#industries'},{label:'Privacy',href:'/privacy'},{label:'Terms',href:'/terms'},{label:'Cookies',href:'/cookies'},{label:'Accessibility',href:'/accessibility'}]}
];

export function Footer(){
 const {siteContent}=useCms();
 const footer=siteContent?.footer||{};
 const groups=(footer.groups?.length?footer.groups:fallbackGroups).slice(0,3);
 const statement=footer.tagline||'Software that becomes operating advantage.';
 const parts=String(statement).split(/\n|(?=operating advantage\.?$)/i);
 return <footer className="footer footer-v232">
 <div className="footer-v232-top">
   <a className="footer-v232-brand" href="/" aria-label="Xynysys Corporation home"><img src="/brand/xynysys-navbar.png" alt="Xynysys Corporation"/></a>
   <div className="footer-v232-statement">{parts[0]||'Software that becomes'}<br/><span>{parts.slice(1).join(' ')||'operating advantage.'}</span></div>
   <a className="footer-v232-cta" href="/book-call">{siteContent?.global?.primaryCta||'Start a project'} <b>↗</b></a>
 </div>
 <div className="footer-v232-grid">
   {groups.map((group:any)=><div key={group.title}><small>{String(group.title||'').toUpperCase()}</small>{(group.links||[]).map((link:any)=><a key={`${link.label}-${link.href}`} href={link.href}>{link.label}</a>)}</div>)}
   <div className="footer-v232-location"><small>BUILT IN</small><strong>{siteContent?.home?.location?.city||'Hamilton'}, {siteContent?.home?.location?.province||'Ontario'}</strong><span>{siteContent?.home?.location?.coordinates||'43.2557° N / 79.8711° W'}</span></div>
 </div>
 <div className="footer-v232-bottom">
   <span>{footer.copyright||`© ${new Date().getFullYear()} Xynysys Corporation`}</span><span>SOFTWARE · AI · CLOUD</span><span>CANADA / DISTRIBUTED</span>
 </div>
 </footer>
}
